// extracted by mini-css-extract-plugin
export default {"table":"MiniCourseTable_table__h9I83","addButton":"MiniCourseTable_addButton__Cpjlr","searchField":"MiniCourseTable_searchField__zfUoe","emptyRow":"MiniCourseTable_emptyRow__Ffs-v"};